/**
 * isiXhosa: Menu and frame
 *
 * What this file covers: The side menu, its section headings, the top bar, the profile menu and the frame
 * around every page.
 *
 * Tone: One or two words per item, like a sign on a door. Nouns, not sentences. Every label must fit a narrow
 * menu. The words chosen here are the names of the pages everywhere else.
 *
 * isiXhosa: Everyday isiXhosa as used in South African business. Keys not translated yet fall back to English,
 * so a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const menu: Catalog = {
  'nav.section.workspace': 'Indawo yokusebenza',
  'nav.section.audience': 'Abaphulaphuli',
  'nav.section.automation': 'Ukuzenzekela',
  'nav.section.settings': 'Useto',
  'nav.section.account': 'I-akhawunti',
  'nav.dashboard': 'Ideshibhodi',
  'nav.inbox': 'Ibhokisi yokungena',
  'nav.contacts': 'Abaqhagamshelwana nabo',
  'nav.broadcasts': 'Usasazo',
  'nav.templates': 'Iitemplethi',
  'nav.flows': 'Ukuhamba',
  'nav.numbers': 'Amanani',
  'nav.billing': 'Ukubhatalisa',
  'nav.settings': 'Useto',
  'nav.menu': 'Imenyu',
  'shell.org.tooltip': 'Umbutho wakho. Vula iisetingi zombutho.',
  'nav.openMenu': 'Vula ukukhangela',
  'nav.closeMenu': 'Vala ukukhangela',
  'shell.wallet.aria': 'Ibhalansi yesipaji {{amount}}. Vula ukuhlawulisa.',
  'nav.developers': 'Abaphuhlisi',
  'nav.channels': 'Iijelo'
};

export default menu;
